import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

export const copy = {
  tr: {
    nav: {
      projects: "Projeler",
      studio: "Stüdyo",
      services: "Hizmetler",
      contact: "İletişim",
      menu: "Menü",
      close: "Kapat",
    },

    intro: {
      tagline: "ARCHITECTURE & DESIGN",
      enter: "Giriş için tıklayın",
    },

    hero: {
      tagline: "ARCHITECTURE & DESIGN",
      location: "İSTANBUL, TÜRKİYE",
      scroll: "Kaydır",
    },

    marquee:
      "Malzeme · Mekân · Işık · Monolit · Beton · Ritim · Zamansız Form · İstanbul · ",

    projects: {
      title: "Seçilmiş Projeler",
      range: "2023 — 2025",
    },

    manifesto: {
      label: "Manifesto",
      chapters: [
        {
          n: "01",
          title: "Malzeme",
          text: "Malzemenin doğal karakterini tasarımın bir parçası olarak ele alıyoruz.",
        },
        {
          n: "02",
          title: "Mekânsal Ritim",
          text: "Oran ve tekrar, mekânın ritmini oluşturur.",
        },
        {
          n: "03",
          title: "Yapı Olarak Işık",
          text: "Işığı, mimarinin atmosferini ve zaman içindeki değişimini belirleyen bir yapı elemanı olarak görüyoruz.",
        },
      ],
    },

    cta: {
      title: "Birlikte bir şey tasarlayalım.",
      link: "İletişime geçin",
    },

    studio: {
      label: "Stüdyo",

      statement: [
        "SOLIDOR, mimarlık ve iç mimarlık",
        "alanında çalışan İstanbul merkezli",
        "bir tasarım stüdyosudur.",
      ],

      aboutLabel: "Hakkında",

      about:
        "Mekânı; oran, malzeme, ışık ve insan deneyimi üzerinden ele alıyoruz. Her projeyi bulunduğu yer, kullanıcı ve malzeme ile kurduğu özgün ilişki üzerinden geliştiriyoruz.",

      approachLabel: "Yaklaşım",

      approach: [
        {
          n: "01",
          title: "Bağlamsal Bütünlük",
          text: "Her proje yeriyle başlar — topografya, iklim, kültür ve ışık.",
        },
        {
          n: "02",
          title: "Tektonik Hassasiyet",
          text: "Yapım biçimi ifadenin kendisidir; birleşim ve detaylar disiplinle çözülür.",
        },
        {
          n: "03",
          title: "Işığın Plastiği",
          text: "Gün ışığı bir malzeme gibi kurgulanır, gün boyunca atmosferi şekillendirir.",
        },
        {
          n: "04",
          title: "Kalıcılık",
          text: "Trendlerin ötesinde, zamana karşı değerini koruyan yapılar tasarlarız.",
        },
      ],

      peopleLabel: "Ekip",
      portrait: "Portre yakında",
      bio: "Biyografi yakında",
    },

    services: {
      label: "Ne yapıyoruz",
      title: "Hizmetler",

      items: [
        {
          title: "Mimarlık",
          text: "Konseptten uygulamaya bütüncül mimari tasarım.",
        },
        {
          title: "İç Mimarlık",
          text: "Mekân, malzeme, mobilya ve detay tasarımı.",
        },
        {
          title: "Tasarım",
          text: "Özel üretim elemanlar, mobilya ve mekânsal çözümler.",
        },
        {
          title: "Görselleştirme",
          text: "Mimari ve iç mimari projeler için görsel anlatım.",
        },
        {
          title: "Proje Geliştirme",
          text: "Fikirden uygulamaya tasarım ve proje koordinasyonu.",
        },
      ],
    },

    contact: {
      lines: ["Birlikte bir şey", "tasarlayalım."],

      emailLabel: "E-posta",
      socialLabel: "Sosyal",
      studioLabel: "Stüdyo",

      form: {
        name: "İsim",
        email: "E-posta",
        phone: "Telefon",
        message: "Mesaj",
        send: "Gönder",
      },

      formError:
        "Mesaj gönderilemedi. Lütfen bilgilerinizi kontrol edip tekrar deneyin.",

      toast:
        "Teşekkürler — mesajınız alındı. En kısa sürede dönüş yapacağız.",
    },

    project: {
      location: "Konum",
      year: "Yıl",
      type: "Tip",
      status: "Durum",
      next: "Sonraki Proje",
      notFound: "Proje bulunamadı",
    },

    footer: {
      studio: "Stüdyo",
      index: "İndeks",
      location: "İstanbul, Türkiye",
    },
  },

  en: {
    nav: {
      projects: "Projects",
      studio: "Studio",
      services: "Services",
      contact: "Contact",
      menu: "Menu",
      close: "Close",
    },

    intro: {
      tagline: "ARCHITECTURE & DESIGN",
      enter: "Click to enter",
    },

    hero: {
      tagline: "ARCHITECTURE & DESIGN",
      location: "ISTANBUL, TÜRKİYE",
      scroll: "Scroll",
    },

    marquee:
      "Matter · Space · Light · Monolith · Concrete · Rhythm · Timeless Form · Istanbul · ",

    projects: {
      title: "Selected Projects",
      range: "2023 — 2025",
    },

    manifesto: {
      label: "The Manifesto",

      chapters: [
        {
          n: "01",
          title: "Materiality",
          text: "We let the natural character of materials define the space.",
        },
        {
          n: "02",
          title: "Spatial Rhythm",
          text: "Proportion and repetition shape the rhythm of space.",
        },
        {
          n: "03",
          title: "Light as Structure",
          text: "Light becomes part of the architecture, shaping atmosphere through time.",
        },
      ],
    },

    cta: {
      title: "Let's create something together.",
      link: "Start a conversation",
    },

    studio: {
      label: "Studio",

      statement: [
        "SOLIDOR is an Istanbul-based architecture",
        "and interior design studio.",
      ],

      aboutLabel: "About",

      about:
        "We approach space through proportion, material, light and human experience. Each project is shaped by its unique relationship with place, people and material.",

      approachLabel: "Approach",

      approach: [
        {
          n: "01",
          title: "Contextual Integrity",
          text: "Every project begins with its place — topography, climate, culture and light.",
        },
        {
          n: "02",
          title: "Tectonic Precision",
          text: "Construction is expression. Joints, weight and assembly are resolved with discipline.",
        },
        {
          n: "03",
          title: "Sculptural Light",
          text: "Daylight is choreographed as a material, shaping atmosphere through the day.",
        },
        {
          n: "04",
          title: "Longevity",
          text: "We design beyond trend — buildings that age with dignity.",
        },
      ],

      peopleLabel: "People",
      portrait: "Portrait forthcoming",
      bio: "Biography forthcoming",
    },

    services: {
      label: "What we do",
      title: "Services",

      items: [
        {
          title: "Architecture",
          text: "Integrated architectural design from concept to construction.",
        },
        {
          title: "Interior Architecture",
          text: "Space, material, furniture and detail design.",
        },
        {
          title: "Design",
          text: "Custom elements, furniture and spatial solutions.",
        },
        {
          title: "Visualization",
          text: "Architectural visualization and visual storytelling.",
        },
        {
          title: "Project Development",
          text: "Design and project coordination from concept to realization.",
        },
      ],
    },

    contact: {
      lines: ["Let's create", "something", "together."],

      emailLabel: "Email",
      socialLabel: "Social",
      studioLabel: "Studio",

      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Message",
        send: "Send",
      },

      formError:
        "Message could not be sent. Please check your details and try again.",

      toast:
        "Thank you — your message has been received. We will be in touch shortly.",
    },

    project: {
      location: "Location",
      year: "Year",
      type: "Type",
      status: "Status",
      next: "Next Project",
      notFound: "Project not found",
    },

    footer: {
      studio: "Studio",
      index: "Index",
      location: "Istanbul, Türkiye",
    },
  },
};

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(
    () => localStorage.getItem("solidor-lang") || "tr"
  );

  useEffect(() => {
    localStorage.setItem("solidor-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider
      value={{
        lang,
        setLang,
        t: copy[lang],
      }}
    >
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
